import {
    clearAuxResourceName,
    clearAuxResourceUrl,
    clearExperienceMarker,
    clearMapBounds,
    setExperienceMarker
} from "./commit_helpers";

// Use this function when an ExperienceMarker is selected - could be via a user action (click) or something else.
export function selectExperienceMarker(sm, mapFilter, experienceMarker) {

    if ( !experienceMarker ) {
        clearExperienceMarker(sm); // Nothing to select.
        return;
    }

    // We deliberately do NOT require the experience to be a member of `mapFilter`. The reveal
    // resolver (route_handlers.js) has already chosen the best backdrop; when the experience is
    // not a member (the ~58 in unpublished-only filters) the map renders it as an ad-hoc pin on
    // top of the backdrop. Previously a non-member cleared the selection, which is exactly why
    // those experiences were never shown. See
    // plans/2026-07-27--experience-navigation-beyond-everything-filter.md.
    clearMapBounds(sm);
    experienceMarker.onlineApp.prefetch(experienceMarker.experience.url);
    clearAuxResourceUrl(sm);
    clearAuxResourceName(sm);
    setExperienceMarker(sm, experienceMarker);
}
